import faceIdIconUrl from '../assets/face-id-icon.svg';
import cacIconUrl from '../assets/cac-icon.svg';
import phoneMfaIconUrl from '../assets/phone-mfa-icon.svg';

/** Prefix for application-specific roles (e.g. 'app:echo') */
export const APP_ROLE_PREFIX = 'app:';

/** Built-in Keycloak roles to exclude from user-facing displays */
export const SYSTEM_ROLES = new Set([
  'default-roles-vertex',
  'offline_access',
  'uma_authorization',
]);

/** Metadata for each supported authentication method */
export interface AuthMethod {
  id: string;
  label: string;
  description: string;
  icon: string;
  credentialType: string;
  keycloakAction: string | null;
}

/** All supported auth methods with their icons and Keycloak mappings */
export const AUTH_METHODS: AuthMethod[] = [
  {
    id: 'cac',
    label: 'CAC / Smart Card',
    description: 'Use your Common Access Card for certificate-based authentication',
    icon: cacIconUrl,
    credentialType: 'x509',
    keycloakAction: null,
  },
  {
    id: 'biometric',
    label: 'Biometric / Passkey',
    description: 'Use fingerprint, face recognition, or a hardware security key',
    icon: faceIdIconUrl,
    credentialType: 'webauthn',
    keycloakAction: 'webauthn-register',
  },
  {
    id: 'mfa',
    label: 'Phone MFA',
    description: 'Use a time-based one-time password from an authenticator app',
    icon: phoneMfaIconUrl,
    credentialType: 'otp',
    keycloakAction: 'CONFIGURE_TOTP',
  },
];

/** Keycloak built-in clients to exclude from app displays */
export const KEYCLOAK_BUILTIN_CLIENTS = new Set([
  'account',
  'account-console',
  'admin-cli',
  'broker',
  'realm-management',
  'security-admin-console',
]);

/** Maps auth method ID → Keycloak credential type (derived from AUTH_METHODS) */
export const METHOD_CREDENTIAL_TYPE: ReadonlyMap<string, string> = new Map(
  AUTH_METHODS.filter(m => m.credentialType).map(m => [m.id, m.credentialType]),
);

/** Builds the localStorage key for CAC-linked status */
export function cacLinkedKey(username: string): string {
  return `vertex-cac-linked-${username}`;
}

/** Utility to format a date timestamp for display */
export function formatDate(timestamp: number): string {
  return new Date(timestamp).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}
